import "./LoadingScreen.scss";
import {LoadingIndicator} from "components/LoadingIndicator";

export const LoadingScreen = () => (
  <div className="loading-screen">
    <LoadingIndicator />
  </div>
);
